import sjcl from 'js/lib/sjcl';

import { ACTIVE_COURSERA_COACH_SESSION_STORAGE_KEY } from 'bundles/ai-course-coach/components/constants';

export function getHashKeyForString(promptText?: string): string {
  // it is expected we will get a string, but incase of failure, we will return a timestamp
  // providing a uniqe value here will ensure that we do not collide with chat session storage keys
  // the probability of creating a collision with timestamps is extremely low, but not impossible. this is a fallback in case of failure.
  if (!promptText) {
    return `${Date.now()}`;
  }
  const keyBytes = sjcl.hash.sha1.hash(promptText);
  const keyHash = sjcl.codec.hex.fromBits(keyBytes);
  return keyHash;
}

export default function createChatSessionStorageKey(uniqueDataString?: string) {
  return `${ACTIVE_COURSERA_COACH_SESSION_STORAGE_KEY}-${getHashKeyForString(uniqueDataString)}`;
}
